import { createAction, props } from '@ngrx/store'
import { PaymentGatewayType } from './gateway-type.model'

export const LoadPaymentGatewayTypes = createAction('[Payment Gateway Type] Load')
export const LoadPaymentGatewayTypesComplete = createAction(
  '[Payment Gateway Type] Load Complete',
  props<{ types: PaymentGatewayType[] }>()
)
